<template>
  <div class="image-dialog">
    <el-dialog
      :lock-scroll="true"
      v-model="_imageDialogVisible"
      width="100%"
      top="0"
      :title="imageCarouselHeaderLabel"
      custom-class="image-dialog bg-opacity-80"
      :close-on-click-modal="false"
      @closed="closeDialog"
    >
      <el-collapse v-model="activeAccordion" accordion>
        <el-collapse-item
          v-for="(value, label) in image"
          :key="label"
          :title="`${label} (${value.length > 0 ? `${imageIndex(label)}/${value.length}` : '0'})`"
          :name="label"
          :disabled="value.length < 1"
        >
          <el-carousel
            :arrow="isShowArrow(label)"
            :autoplay="false"
            @change="onCarouselImageChange"
            indicator-position="none"
          >
            <el-carousel-item v-for="(image, index) in value" :key="index">
              <el-image
                :preview-teleported="true"
                :preview-src-list="[`${image?.url}`]"
                style="align-self: center"
                :src="image?.url"
                fit="contain"
              >
                <template #error>
                  <div style="height: 20px">{{ $t('image_not_found') }}</div>
                </template>
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { IFile } from '@/utils/types'
import { Options, Vue } from 'vue-class-component'
import { Emit, Prop, PropSync, Watch } from 'vue-property-decorator'

// Mixins
@Options({
  components: {
    name: 'ImageViewDialog',
  },
  emits: ['update:modelValue', 'update:imageDialogVisible'],
})
export default class ImageViewDialog extends Vue {
  @PropSync('imageDialogVisible') _imageDialogVisible!: boolean
  @Prop() readonly image: Record<string, IFile[]> = {}
  activeAccordion = ''
  imagesIndex: Record<string, number> = {}

  @Emit('update:imageDialogVisible')
  closeDialog() {
    return false
  }

  onCarouselImageChange(newVal: number) {
    if (this.imagesIndex[this.activeAccordion] !== undefined) {
      this.imagesIndex[this.activeAccordion] = newVal
    }
  }

  imageIndex(label: string) {
    return this.imagesIndex[label] + 1 || 0
  }

  created() {
    this.initImagesIndex()
  }

  @Watch('image')
  onImagePropChanged() {
    this.initImagesIndex()
  }

  initImagesIndex() {
    Object.keys(this.image).forEach((label) => {
      this.imagesIndex = {
        ...this.imagesIndex,
        [label]: 0,
      }
    })
  }

  isShowArrow(label: string) {
    return this.image[label].length > 1 ? 'always' : 'never'
  }

  get imageCarouselHeaderLabel() {
    return this.$t('barcode.pictures')
  }
}
</script>
<style lang="scss" scoped>
@import './src/assets/css/mixins.scss';
.image-dialog {
  &.el-dialog {
    .el-dialog__body {
      padding-top: 0;
    }
  }
}
.image-dialog:deep() {
  &.el-dialog {
    background-color: #f2f2f2;
    border-radius: 10px;
    max-height: 90%;
    overflow: hidden;
    flex-direction: column;
    display: flex;
    margin: 0;

    &__header {
      font-weight: bold;
      border-bottom: 1px solid #bdbdbd;
      padding: 25px;
      span {
        font-weight: bold;
      }
    }

    &__body {
      padding-top: 00px;
      padding-right: 0px;
      padding-bottom: 30px;
      padding-left: 0px;
      .el-collapse {
        &-item {
          &__header {
            background: none;
            border: 1px #bdbdbd;
            border-bottom: 1px solid #bdbdbd;
            padding-left: 28px;

            i {
              display: none;
            }
          }
          &__wrap {
            background: #dfdfdf;
          }
          &__content {
            padding-bottom: 0px;
          }
        }
      }
      .el-carousel {
        &__arrow {
          background: #bdbdbd;
          i::before {
            font-size: 20px;
            font-weight: 900;
          }
        }
      }
    }
  }
}
</style>
